/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Delete_TooltipInputs */



/**
* | output |
* | --- |
* | "The module cannot be deleted if the building is in Summer / Winter with half-season mode A building without a module cannot be in Summer / Winter mode with h..." |
*
* @param {Module_Settings_Delete_TooltipInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_delete_tooltip = /** @type {((inputs?: Module_Settings_Delete_TooltipInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Delete_TooltipInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The module cannot be deleted if the building is in Summer / Winter with half-season mode\nA building without a module cannot be in Summer / Winter mode with half-season")
	return /** @type {LocalizedString} */ ("Le module ne peut pas être supprimé si le bâtiment et en mode Été / Hiver avec mi-saison\nUn bâtiment sans module ne peut pas être en mode Été / Hiver avec mi-saison")
});